import { EVENT } from '../constants'
import { toAnalyticsBrokerId } from '../brokerAnalyticsContext'
import trackEventFirebaseService from '../services/firebase'
import sendDeviceInfo from './sendDeviceInfo'

/** Borrar junto con el uso en shouldSendEmissionFirebaseEvent cuando el backend no vehicular esté listo. */
const ENABLE_NON_VEHICLE_EMISSION_FIREBASE_EVENTS = false

function shouldSendEmissionFirebaseEvent(isVehicleEmission) {
    return isVehicleEmission || ENABLE_NON_VEHICLE_EMISSION_FIREBASE_EVENTS
}

export function buildEmissionEventParams(store, { policyEmitted = null, error = null } = {}) {
    const params = {
        multiquoteType: store.multiQuoteType ?? '',
        brokerId: toAnalyticsBrokerId(store.brokerOwner?.id),
        customerType: store.customerType ?? '',
        insuranceCompany: store.insuranceCompany ?? '',
        emissionId: store.emissionId?.value ?? '',
    }

    if (policyEmitted) {
        params.policyNumber = policyEmitted.policyNumber ?? ''
        params.policyId = policyEmitted.id ?? ''
    }

    if (error?.message) {
        params.error = error.message
    }

    return params
}

export function sendEmissionSuccessFirebaseEvent(store, policyEmitted = null) {
    const params = buildEmissionEventParams(store, { policyEmitted })
    if (shouldSendEmissionFirebaseEvent(store.isVehicleEmission)) {
        trackEventFirebaseService(EVENT.KEY.EMISSION_SUCCESS, params)
    }

    sendDeviceInfo(EVENT.KEY.EMISSION_SUCCESS)
}

export function sendEmissionErrorFirebaseEvent(store, error) {
    const params = buildEmissionEventParams(store, { error })
    if (shouldSendEmissionFirebaseEvent(store.isVehicleEmission)) {
        trackEventFirebaseService(EVENT.KEY.EMISSION_ERROR, params)
    }

    sendDeviceInfo(EVENT.KEY.EMISSION_ERROR)
}
